<div class="shift-compliance-container">
	<div class="d-flex flex-column flex-lg-row justify-content-between">
		<img
			class="shift-compliance-left"
			src="../assets/img/security-arch.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h2 class="shift-compliance-header">Our Security Architecture</h2>
			<ul class="security-list">
				<li>End-to-end encryption</li>
				<li>Stateless authentication</li>
				<li>Micro-segmentation</li>
				<li>
					Mirrored authorization between the front-end and back-end
				</li>
			</ul>
		</div>
	</div>
</div>
